module.exports = __webpack_public_path__ + "static/media/restaurants.0ec9f6bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/elements/screen-images/travel/restaurants.jpg
// module id = 757
// module chunks = 0